import { useTranslation } from "react-i18next";
import NavigationMarketing from "@/components/NavigationMarketing";
import ProofStrip from "@/components/marketing/ProofStrip";
import OneControl from "@/components/marketing/OneControl";
import LanguageModelObjection from "@/components/marketing/LanguageModelObjection";
import ContentPackGrid from "@/components/marketing/ContentPackGrid";
import TodayOnTheTrail from "@/components/marketing/TodayOnTheTrail";

import PlatformSnapshot from "@/components/PlatformSnapshot";
import CertificationConstellation from "@/components/marketing/CertificationConstellation";
import WeAreYourGuide from "@/components/WeAreYourGuide";
import VibeCompliance from "@/components/marketing/VibeCompliance";

import FinalCTABand from "@/components/marketing/FinalCTABand";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { organizationSchema, webSiteSchema, softwareApplicationSchema } from "@/utils/structuredData";

const homepageStructuredData = [organizationSchema, webSiteSchema, softwareApplicationSchema];


const Index = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      <SEOHead
        title={t('indexPage.seoTitle')}
        description={t('indexPage.seoDesc')}
        keywords="multi-framework compliance, DORA compliance, NIS2, EU AI Act, FedRAMP, HITRUST, BSA/AML, Single Audit, 2 CFR 200, control mapping, continuous controls monitoring, regulatory intelligence, GRC platform"
        structuredData={homepageStructuredData}
      />
      <NavigationMarketing />
      <main id="main-content" role="main">
        <VibeCompliance />
        <ProofStrip />

        {/* Position sections, high on the page per Messaging Architecture v1.0:
            the problem lands first, the packs are the proof it is solvable. */}
        <section id="problem">
          <OneControl />
        </section>
        <LanguageModelObjection />
        {/* Editorial, rotates daily. It sat under the hero and pushed the second
            rail past the fold; the first screen belongs to the position. It now
            opens the packs screen instead of closing it, so the pack tiles are
            the last thing on that screen rather than the first thing cut off. */}
        <TodayOnTheTrail />

        <section id="packs">
          <ContentPackGrid />
        </section>

        <CertificationConstellation />

        <section id="platform">
          <PlatformSnapshot />
        </section>

        <WeAreYourGuide />

        <FinalCTABand />

      </main>
      <Footer />
    </div>
  );
};

export default Index;
